<template>
    <div class="main">
        <a-card style="border-radius: 20px;" :bordered="false">
            <div class="actions">
                <h3 style="font-size:28px;line-height:45px">Accounts</h3>
                <div>
                    <a-button @click="showAddCustomerModal"
                        style="height:38px;border-raduis:5px; background: #418a49; color:#fff;" icon="plus">
                        Add New Account
                    </a-button>
                </div>
            </div>
            <a-row class="mt-5">
                <a-col :span="24">
                    <div class="card-container">
                        <a-tabs type="card">
                            <a-tab-pane key="1">
                                <span slot="tab">
                                    <span>
                                        <a-icon type="unordered-list" />
                                    </span>
                                    All Accounts
                                    <a-badge style="float:right;padding-top:9px" :count="displayTotalAccounts"
                                        show-zero />
                                </span>
                                <div class="requestActions">
                                    <!-- <a-form-model
                                    :model="orderform"
                                >
                                    <a-form-model-item>
                                        <a-input style="width: 274px;height: 35px;border-raduis:5px;" v-model="orderform.searchText" placeholder="quich search order...">
                                            <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
                                        </a-input>
                                    </a-form-model-item>
                                </a-form-model> -->
                                    <div>
                                        <a-button @click="exportAllOrders"
                                            style="height:38px;border-raduis:5px; background: #418a49; color:#fff;"
                                            icon="export">
                                            Export
                                        </a-button>
                                    </div>
                                </div>
                                <div>
                                    <a-table :columns="columns" :scroll="{ x: 1500, y: 600 }"
                                        :data-source="customerData" :loading='tableLoading' :pagination="pagination"
                                        class="tableStyle">
                                        <div slot="filterDropdown"
                                            slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                            style="padding: 8px">
                                            <a-input v-ant-ref="c => (searchInput = c)"
                                                :placeholder="`Search ${column.dataIndex}`" :value="selectedKeys[0]"
                                                style="width: 188px; margin-bottom: 8px; display: block;"
                                                @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                                                @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                                            <a-button type="primary" icon="search" size="small"
                                                style="width: 90px; margin-right: 8px"
                                                @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                                                Search
                                            </a-button>
                                            <a-button size="small" style="width: 90px"
                                                @click="() => handleReset(clearFilters)">
                                                Reset
                                            </a-button>
                                        </div>

                                        <template slot="action" slot-scope="data">
                                            <a-dropdown>
                                                <a style="color:#98c14b;" class="ant-dropdown-link"
                                                    @click="e => e.preventDefault()">
                                                    <a-icon style="font-size:25px;" type="ellipsis" />
                                                </a>
                                                <a-menu slot="overlay">
                                                    <a-menu-item>
                                                        <a @click="showMoreDetailsModal(data)">More Details?</a>
                                                    </a-menu-item>
                                                    <a-menu-item>
                                                        <a @click="showUpdateCustomer(data)">Update Customer?</a>
                                                    </a-menu-item>
                                                    <a-menu-item>
                                                        <a @click="showTierModal(data)">Update Customer Tier?</a>
                                                    </a-menu-item>
                                                    <a-menu-item>
                                                        <a @click="showEnableCustomer(data)">Enable Customer?</a>
                                                    </a-menu-item>
                                                    <a-menu-item>
                                                        <a @click="showDisabledCustomer(data)">Disable Customer?</a>
                                                    </a-menu-item>
                                                </a-menu>
                                            </a-dropdown>
                                        </template>

                                        <template slot="tier" slot-scope='data'>
                                            <div
                                                style="display: flex;padding-top: 4px;justify-content: space-around;background: #3f51b5;width: 140px;height: 27px;border-radius: 30px">
                                                <p style="font-size:12px;color:#fff;">Tier {{ data }}</p>
                                            </div>
                                        </template>

                                        <template slot="status" slot-scope='data'>
                                            <status-component :status="data"></status-component>
                                        </template>
                                    </a-table>
                                </div>

                            </a-tab-pane>
                            <a-tab-pane key="2">
                                <span slot="tab">
                                    <span>
                                        <a-icon type="unordered-list" />
                                    </span>
                                    Active Account
                                    <a-badge style="float:right;padding-top:9px" :count="displayTotalAccounts"
                                        show-zero />
                                </span>
                                <div class="requestActions">
                                    <a-button @click="exportAllNewCustomers"
                                        style="height:38px;border-raduis:5px; background: #418a49; color:#fff;"
                                        icon="export">
                                        Export
                                    </a-button>
                                </div>
                                <div>
                                    <a-table :columns="columns" :scroll="{ x: 1500, y: 600 }"
                                        :data-source="customerData" :loading='tableLoading' :pagination="pagination"
                                        class="tableStyle">
                                        <template slot="action" slot-scope="data">
                                            <a-dropdown>
                                                <a style="color:#98c14b;" class="ant-dropdown-link"
                                                    @click="e => e.preventDefault()">
                                                    <a-icon style="font-size:25px;" type="ellipsis" />
                                                </a>
                                                <a-menu slot="overlay">
                                                    <a-menu-item>
                                                        <a @click="showMoreDetailsModal(data)">More Details?</a>
                                                    </a-menu-item>
                                                    <a-menu-item>
                                                        <a @click="showUpdateCustomer(data)">Update Customer?</a>
                                                    </a-menu-item>
                                                    <a-menu-item>
                                                        <a @click="showTierModal(data)">Update Customer Tier?</a>
                                                    </a-menu-item>
                                                    <a-menu-item>
                                                        <a @click="showEnableCustomer(data)">Enable Customer?</a>
                                                    </a-menu-item>
                                                    <a-menu-item>
                                                        <a @click="showDisabledCustomer(data)">Disable Customer?</a>
                                                    </a-menu-item>
                                                </a-menu>
                                            </a-dropdown>
                                        </template>

                                        <template slot="tier" slot-scope='data'>
                                            <div
                                                style="display: flex;padding-top: 4px;justify-content: space-around;background: #3f51b5;width: 140px;height: 27px;border-radius: 30px">
                                                <p style="font-size:12px;color:#fff;">Tier {{ data }}</p>
                                            </div>
                                        </template>

                                        <template slot="status" slot-scope='data'>
                                            <status-component :status="data"></status-component>
                                        </template>
                                    </a-table>
                                </div>

                            </a-tab-pane>
                            <a-tab-pane key="3">
                                <span slot="tab">
                                    <span>
                                        <a-icon type="unordered-list" />
                                    </span>
                                    Dormant Account
                                    <a-badge style="float:right;padding-top:9px" :count="displayTotalAccounts"
                                        show-zero />
                                </span>
                                <div class="requestActions">
                                    <a-button @click="exportAllActiveData"
                                        style="height:38px;border-raduis:5px; background: #418a49; color:#fff;"
                                        icon="export">
                                        Export
                                    </a-button>
                                </div>
                                <div>
                                    <a-table :columns="columns" :scroll="{ x: 1500, y: 600 }"
                                        :data-source="customerData" :loading='tableLoading' :pagination="pagination"
                                        class="tableStyle">
                                        <template slot="action" slot-scope="data">
                                            <a-dropdown>
                                                <a style="color:#98c14b;" class="ant-dropdown-link"
                                                    @click="e => e.preventDefault()">
                                                    <a-icon style="font-size:25px;" type="ellipsis" />
                                                </a>
                                                <a-menu slot="overlay">
                                                    <a-menu-item>
                                                        <a @click="showMoreDetailsModal(data)">More Details?</a>
                                                    </a-menu-item>
                                                    <a-menu-item>
                                                        <a @click="showUpdateCustomer(data)">Update Customer?</a>
                                                    </a-menu-item>
                                                    <a-menu-item>
                                                        <a @click="showTierModal(data)">Update Customer Tier?</a>
                                                    </a-menu-item>
                                                    <a-menu-item>
                                                        <a @click="showEnableCustomer(data)">Enable Customer?</a>
                                                    </a-menu-item>
                                                    <a-menu-item>
                                                        <a @click="showDisabledCustomer(data)">Disable Customer?</a>
                                                    </a-menu-item>
                                                </a-menu>
                                            </a-dropdown>
                                        </template>

                                        <template slot="tier" slot-scope='data'>
                                            <div
                                                style="display: flex;padding-top: 4px;justify-content: space-around;background: #3f51b5;width: 140px;height: 27px;border-radius: 30px">
                                                <p style="font-size:12px;color:#fff;">Tier {{ data }}</p>
                                            </div>
                                        </template>

                                        <template slot="status" slot-scope='data'>
                                            <status-component :status="data"></status-component>
                                        </template>
                                    </a-table>
                                </div>

                            </a-tab-pane>
                            <a-tab-pane key="4">
                                <span slot="tab">
                                    <span>
                                        <a-icon type="unordered-list" />
                                    </span>
                                    Pending Account
                                    <a-badge style="float:right;padding-top:9px" :count="displayTotalAccounts"
                                        show-zero />
                                </span>
                                <div class="requestActions">
                                    <a-button @click="exportAllDisabled"
                                        style="height:38px;border-raduis:5px; background: #418a49; color:#fff;"
                                        icon="export">
                                        Export
                                    </a-button>
                                </div>
                                <div>
                                    <a-table :columns="columns" :scroll="{ x: 1500, y: 600 }"
                                        :data-source="customerData" :loading='tableLoading' :pagination="pagination"
                                        class="tableStyle">
                                        <template slot="action" slot-scope="data">
                                            <a-dropdown>
                                                <a style="color:#98c14b;" class="ant-dropdown-link"
                                                    @click="e => e.preventDefault()">
                                                    <a-icon style="font-size:25px;" type="ellipsis" />
                                                </a>
                                                <a-menu slot="overlay">
                                                    <a-menu-item>
                                                        <a @click="showMoreDetailsModal(data)">More Details?</a>
                                                    </a-menu-item>
                                                    <a-menu-item>
                                                        <a @click="showUpdateCustomer(data)">Update Customer?</a>
                                                    </a-menu-item>
                                                    <a-menu-item>
                                                        <a @click="showTierModal(data)">Update Customer Tier?</a>
                                                    </a-menu-item>
                                                    <a-menu-item>
                                                        <a @click="showEnableCustomer(data)">Enable Customer?</a>
                                                    </a-menu-item>
                                                    <a-menu-item>
                                                        <a @click="showDisabledCustomer(data)">Disable Customer?</a>
                                                    </a-menu-item>
                                                </a-menu>
                                            </a-dropdown>
                                        </template>

                                        <template slot="tier" slot-scope='data'>
                                            <div
                                                style="display: flex;padding-top: 4px;justify-content: space-around;background: #3f51b5;width: 140px;height: 27px;border-radius: 30px">
                                                <p style="font-size:12px;color:#fff;">Tier {{ data }}</p>
                                            </div>
                                        </template>

                                        <template slot="status" slot-scope='data'>
                                            <status-component :status="data"></status-component>
                                        </template>
                                    </a-table>
                                </div>
                            </a-tab-pane>
                        </a-tabs>
                    </div>
                </a-col>
                <!-- <a-col  :span="9" :offset="1">
            <div style="background:#fff;padding:20px;border-radius:6px;box-shadow:rgb(0 0 0 / 9%) 0px 2px 10px;margin-bottom:30px">
                <div class="d-flex justify-content-between">
                    <div style="font-size:16px">Top Performing Accounts</div>
                    <div style="font-size:16px">
                        <a-select default-value="Customer" style="width: 120px">
                                <a-select-option value="Customer">
                                    Customer
                                </a-select-option>
                                <a-select-option value="Distribution Center">
                                    Distribution Center
                                </a-select-option>
                                <a-select-option value="Order">
                                    Order
                                </a-select-option>
                            </a-select>
                    </div>
                </div>
                <div class="pb-3">
                    <a style="font-size:14px;" href="#">Click to view reports</a>
                </div>
                <div v-for="customer in customerData" :key="customer.id">
                    <customer-stats :customer="customer"></customer-stats>
                    <a-divider />
                </div>
            
            </div>
            <div style="background:#fff;padding:20px;border-radius:6px;box-shadow:rgb(0 0 0 / 9%) 0px 2px 10px">
                <div class="d-flex justify-content-between">
                  <div style="font-size:16px">Unperforming Accounts</div>
                  <div style="font-size:16px">
                       <a-select default-value="Customer" style="width: 120px">
                            <a-select-option value="Customer">
                                Customer
                            </a-select-option>
                            <a-select-option value="Distribution Center">
                                Distribution Center
                            </a-select-option>
                            <a-select-option value="Order">
                                Order
                            </a-select-option>
                        </a-select>
                  </div>
              </div>
              <div class="pb-3">
                  <a style="font-size:14px;" href="#">Click to view reports</a>
              </div>
              <div v-for="customer in customerData2" :key="customer.id">
                  <customer-stats :customer="customer"></customer-stats>
                   <a-divider />
              </div>
            </div>
              
          </a-col> -->
            </a-row>


            <a-modal class="modalStyle" :visible="addCustomerVisible" width="600px" :footer="null"
                @cancel="handleAddCustomerCancel">

                <h3
                    style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;padding-bottom:30px">
                    Add New
                    Account</h3>
                <div>
                    <!-- <a-form-model ref="addCustomerForm" :model="addCustomerModel" :rules="rules">
                        <a-row>
                            <a-col :span="10" :offset="1">
                                <a-form-model-item label="Customer Name" ref="name" prop="name">
                                    <a-input class="" v-model="addCustomerModel.name" />
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="10" :offset="2">
                                <a-form-model-item label="Customer Address" ref="address" prop="address">
                                    <a-input class="" v-model="addCustomerModel.address" />
                                </a-form-model-item>
                            </a-col>
                        </a-row>

                        <a-row>
                            <a-col :span="10" :offset="1">
                                <a-form-model-item label="Phone Number" ref="phoneNumber" prop="phoneNumber">
                                    <a-input class="" v-model="addCustomerModel.phoneNumber" />
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="10" :offset="1">
                                <a-form-model-item label="Select Community" ref="communityId" prop="communityId">
                                    <a-select v-model="addCustomerModel.communityId"
                                        placeholder="please select your community">
                                        <a-select-option v-for="community in availableCommunity" :key="community.id"
                                            v-bind:value="community.id">
                                            {{ community.name }}
                                        </a-select-option>
                                    </a-select>
                                </a-form-model-item>
                            </a-col>
                        </a-row>

                     
                        <a-form-model-item
                            style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                            <a-button @click="handleAddCustomerSubmit" :loading="loading"
                                style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                                Add New Customer
                            </a-button>
                        </a-form-model-item>

                    </a-form-model> -->
                </div>
            </a-modal>

            <a-modal class="modalStyle" :visible="updateCustomerVisible" width="600px" :footer="null"
                @cancel="handleUpdateCustomerCancel">

                <h3
                    style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;padding-bottom:30px">
                    Update
                    Customer</h3>
                <div>
                    <a-form-model ref="updateCustomerForm" :model="updateCustomerModel" :rules="rules">
                        <a-row>
                            <a-col :span="10" :offset="1">
                                <a-form-model-item label="Customer Name" ref="name" prop="name">
                                    <a-input class="" v-model="updateCustomerModel.name" />
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="10" :offset="2">
                                <a-form-model-item label="Customer Address" ref="address" prop="address">
                                    <a-input class="" v-model="updateCustomerModel.address" />
                                </a-form-model-item>
                            </a-col>
                        </a-row>

                        <a-row>
                            <a-col :span="10" :offset="1">
                                <a-form-model-item label="Phone Number" ref="phoneNumber" prop="phoneNumber">
                                    <a-input class="" v-model="updateCustomerModel.phoneNumber" />
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="10" :offset="1">
                                <a-form-model-item label="Select Community" ref="communityId" prop="communityId">
                                    <a-select v-model="updateCustomerModel.communityId"
                                        placeholder="please select your community">
                                        <a-select-option v-for="community in availableCommunity" :key="community.id"
                                            v-bind:value="community.id">
                                            {{ community.name }}
                                        </a-select-option>
                                    </a-select>
                                </a-form-model-item>
                            </a-col>
                        </a-row>

                        <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                            <a-spin class="spinner" :spinning="loading" />
                        </div>

                        <a-form-model-item
                            style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                            <a-button @click="handleUpdateCustomerSubmit"
                                style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                                Update Customer
                            </a-button>
                        </a-form-model-item>

                    </a-form-model>
                </div>
            </a-modal>
            <a-modal class="modalStyle" :visible="updateCustomerTierVisible" width="600px" :footer="null"
                @cancel="handleUpdateCustomerTierCancel">

                <h3
                    style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;padding-bottom:30px">
                    Update
                    Customer Tier</h3>
                <div>
                    <a-form-model ref="updateCustomerTierForm" :model="updateCustomerTierModel" :rules="rules">
                        <a-row>
                            <a-col :span="22" :offset="1">
                                <a-form-model-item label="Select Customer Tier" ref="tier" prop="tier">
                                    <a-select v-model="updateCustomerTierModel.tier"
                                        placeholder="please select your tier">
                                        <a-select-option v-for="tier in availableTiers" :key="tier.tier"
                                            v-bind:value="tier.tier">
                                            {{ tier.tierLabel }}
                                        </a-select-option>
                                    </a-select>
                                </a-form-model-item>
                            </a-col>
                        </a-row>

                        <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                            <a-spin class="spinner" :spinning="loading" />
                        </div>

                        <a-form-model-item
                            style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                            <a-button @click="handleCustomerTierSubmit"
                                style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                                Update Customer Tier
                            </a-button>
                        </a-form-model-item>

                    </a-form-model>
                </div>
            </a-modal>
        </a-card>

    </div>
</template>
<script>
import { mapActions } from 'vuex';
import moment from 'moment';
import XLSX from "xlsx";
import _ from 'lodash';
import { filterNewData14DaysAgo } from '../../utils/index'
import StatusComponent from '../shared-components/StatusComponent.vue'
// import CustomerStats from './custom/CustomerStats.vue'

const columns = [
    {
        title: 'Account #',
        width: 200,
        key: 'id',
        dataIndex: 'id',
    },
    {
        title: 'Account Name',
        key: 'name',
        width: 200,
        dataIndex: 'name',
    },
    {
        title: 'Account Type',
        dataIndex: 'accountType',
        key: 'accountType',
        width: 200,
    },
    {
        title: 'Parent Account',
        dataIndex: 'pAccount',
        key: 'pAccount',
        width: 200,
    },
    {
        title: 'Account Owner',
        dataIndex: 'accountOwner',
        key: 'accountOwner',
        width: 200,
    },
    {
        title: 'Sale Zone',
        dataIndex: 'saleZone',
        key: 'saleZone',
        width: 200,
    },
    {
        title: 'Phone',
        dataIndex: 'phoneNumber',
        key: 'phoneNumber',
        width: 200,
    },
    {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        width: 200,
    },
    {
        title: 'Expected Sales',
        dataIndex: 'expectedSales',
        key: 'expectedSales',
        width: 200,
    },
    {
        title: 'Actual Purchase',
        dataIndex: 'actualPurchase',
        key: 'actualPurchase',
        width: 200,
    },
    {
        title: 'AOV',
        dataIndex: 'aov',
        key: 'aov',
        width: 200,
    },
    {
        title: 'Status',
        key: 'status',
        dataIndex: 'status',
        width: 200,
        scopedSlots: { customRender: 'status' }
    },
    {
        title: 'Last Interacted On',
        dataIndex: 'interactedDate',
        width: 200,
    },

    // {
    //     title: 'Action',
    //     key: 'action',
    //     dataIndex: 'action',
    //     // width: 150,
    //     scopedSlots: { customRender: 'action' }
    // },
];

const columnsStatues = [
    {
        title: 'Account #',
        width: 200,
        key: 'id',
        dataIndex: 'id',
    },
    {
        title: 'Account Name',
        key: 'name',
        width: 200,
        dataIndex: 'name',
    },
    {
        title: 'Account Type',
        dataIndex: 'accountType',
        key: 'accountType',
        width: 200,
    },
    {
        title: 'Parent Account',
        dataIndex: 'pAccount',
        key: 'pAccount',
        scopedSlots: { customRender: 'tier' },
         width: 200,
    },
    {
        title: 'Account Owner',
        dataIndex: 'accountOwner',
        key: 'accountOwner',
        width: 200,
    },
    {
        title: 'Sale Zone',
        dataIndex: 'saleZone',
        key: 'saleZone',
        width: 200,
    },
    {
        title: 'Phone',
        dataIndex: 'phoneNumber',
        key: 'phoneNumber',
        width: 200,
    },
    {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        width: 200,
    },
    {
        title: 'Expected Sales',
        dataIndex: 'expectedSales',
        key: 'expectedSales',
        width: 200,
    },
    {
        title: 'Actual Purchase',
        dataIndex: 'actualPurchase',
        key: 'actualPurchase',
        width: 200,
    },
    {
        title: 'AOV',
        dataIndex: 'aov',
        key: 'aov',
        width: 180,
    },
    {
        title: 'Status',
        key: 'status',
        dataIndex: 'status',
        // width: 250,
        scopedSlots: { customRender: 'status' }
    },
    {
        title: 'Last Interacted On',
        dataIndex: 'interactedDate',
        // width: 180,
    },

    // {
    //     title: 'Action',
    //     key: 'action',
    //     dataIndex: 'action',
    //     // width: 150,
    //     scopedSlots: { customRender: 'action' }
    // },
];

const customerData = [
    {
        id: 10876,
        name: 'Agrodem Gadaf Ltd',
        accountType: 'Shop Agrovet',
        pAccount: 'Issa Amu ',
        accountOwner: 'Peter Awin',
        saleZone: 'Tamale',
        phoneNumber: '0541539069',
        email: 'Goodman@gmail.com',
        expectedSales: '10,000',
        actualPurchase: '9,000',
        aov: '10,000',
        status: 'Active',
        interactedDate: '26-03-2024',
    },
    {
        id: 10878,
        name: 'Agrodem Gadaf Ltd',
        accountType: 'Shop Agrovet',
        pAccount: 'Issa Amu ',
        accountOwner: 'Peter Awin',
        saleZone: 'Tamale',
        phoneNumber: '0541539069',
        email: 'Goodman@gmail.com',
        expectedSales: '10,000',
        actualPurchase: '9,000',
        aov: '10,000',
        status: 'Dormant',
        interactedDate: '26-03-2024',
    },
    {
        id: 10889,
        name: 'Agrodem Gadaf Ltd',
        accountType: 'Shop Agrovet',
        pAccount: 'Issa Amu ',
        accountOwner: 'Peter Awin',
        saleZone: 'Tamale',
        phoneNumber: '0541539069',
        email: 'Goodman@gmail.com',
        expectedSales: '10,000',
        actualPurchase: '9,000',
        aov: '10,000',
        status: 'Pending',
        interactedDate: '26-03-2024',
    },
]
const customerData2 = [
    {
        id: 1,
        name: 'Cowtribe Enterprise',
        address: 'Tamle',
        amount: 189990,
        rate: 8,
        status: 'increase'
    },
    {
        id: 2,
        name: 'Adama Vet',
        address: 'Teshie',
        amount: 150990,
        rate: 11,
        status: 'increase'
    },
    {
        id: 3,
        name: 'Emejours Petshop & Vet Supplies',
        address: 'Accra',
        amount: 134990,
        rate: 2,
        status: 'decrease'
    }
]

export default {
    name: 'Accounts',
    components: {
        StatusComponent,
        // CustomerStats
    },
    data() {
        return {
            dateFormat: 'YYYY-MM-DD',
            startDate: moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
            endDate: moment().add(1, 'd').format('YYYY-MM-DD'),
            searchText: '',
            columns,
            columnsStatues,
            customerData,
            customerData2,
            searchInput: null,
            searchedColumn: '',
            product: {},
            tableAllCustomersData: [],
            tableNewCustomersData: [],
            tableActiveCustomerData: [],
            tableInActiveCustomerData: [],
            availableRetailers: [],
            availableClientProducts: [],
            availableCommunity: [],
            availableTiers: [],
            exportLoading: false,
            addCustomerVisible: false,
            updateCustomerVisible: false,
            updateCustomerTierVisible: false,
            pagination: {
                pageSize: 20
            },
            params: {
                page: -1,
                perPage: -1,
                searchBy: {},
                sortBy: {}
            },
            addCustomerModel: {
                name: '',
                phoneNumber: '',
                address: '',
                communityId: ''
            },
            updateCustomerModel: {
                name: '',
                phoneNumber: '',
                address: '',
                communityId: ''
            },
            updateCustomerTierModel: {
                tier: ''
            },
            selectedCustomer: {},
            productId: "",
            loading: false,
            tableLoading: false,
            rules: {
                communityId: [
                    { required: true, message: 'Please choose your option', trigger: 'change' },

                ],
                name: [
                    { required: true, message: 'Please enter name', trigger: 'change' },

                ],

                tier: [
                    { required: true, message: 'Please enter tier', trigger: 'change' },

                ],
                phoneNumber: [
                    { required: true, message: 'Please enter phone number', trigger: 'change' },

                ],
                address: [
                    { required: true, message: 'Please enter address', trigger: 'change' },

                ],
                quantity: [
                    { required: true, message: 'Please enter your quantity', trigger: 'change' },
                    {
                        pattern: new RegExp(/^[1-9]\d*$/),
                        message: 'Please enter valid number',
                        trigger: 'change'
                    },
                ],
                sellingPrice: [
                    { required: true, message: 'Please enter selling price', trigger: 'change' },
                    {
                        pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),
                        message: 'Please enter valid number',
                        trigger: 'change'
                    },
                ],
                purchasePrice: [
                    { required: true, message: 'Please enter purchase price', trigger: 'change' },
                    {
                        pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),
                        message: 'Please enter valid number',
                        trigger: 'change'
                    },
                ],
            },

        };
    },
    computed: {
        displayTotalAccounts() {
            return this.customerData.length
        },
        displayTotalNewCustomers() {
            return this.tableNewCustomersData.length
        },
        displayTotalActiveCustomers() {
            return this.tableActiveCustomerData.length
        },
        displayTotalInActiveCustomers() {
            return this.tableInActiveCustomerData.length
        },

    },
    methods: {
        ...mapActions(['getAllRetailers', 'updateNewCustomer', 'updateCustomerTier', 'updateCustomerStatus', 'addNewCustomer', 'setCustomerInfo', 'getAllCommunities']),
        moment,
        handleSearch(selectedKeys, confirm, dataIndex) {
            confirm();
            this.searchText = selectedKeys[0];
            this.searchedColumn = dataIndex;
        },
        handleReset(clearFilters) {
            clearFilters();
            this.searchText = '';
        },
        showMoreDetailsModal(data) {
            this.setCustomerInfo(data);
            this.$router.push(`/customers-details`).catch(() => { });
        },

        showSuccessAlert(message) {
            this.$notification['success']({
                message: message,
            });
        },

        showErrorAlert(message) {
            this.$notification['error']({
                message: message
            });
        },

        showUpdateCustomer(data) {
            this.selectedCustomer = data
            this.updateCustomerModel.name = data.name
            this.updateCustomerModel.phoneNumber = data.phoneNumber
            this.updateCustomerModel.address = data.address
            this.updateCustomerModel.communityId = data.communityId
            this.updateCustomerVisible = true
        },

        showTierModal(data) {
            this.selectedCustomer = data
            // console.log("data |", data)
            this.updateCustomerTierModel.tier = data.tier
            this.updateCustomerTierVisible = true
        },

        handleUpdateCustomerTierCancel() {
            this.updateCustomerTierVisible = false
        },

        showEnableCustomer(data) {
            this.tableLoading = true

            const request = {
                id: data.id,
                IsActive: true
            }

            // console.log("request | ", request)
            this.updateCustomerStatus(request).then(response => {

                this.tableLoading = false;
                if (response.status === 200) {
                    this.loadCustomersData();
                    this.showSuccessAlert("Customer Details Updated Successfully")
                } else {
                    this.showErrorAlert(response.data.messages)
                }
            },
                error => {
                    this.tableLoading = false
                    this.showErrorAlert(JSON.stringify(error))
                })
        },

        handleCustomerTierSubmit() {

            this.$refs.updateCustomerTierForm.validate(valid => {
                if (valid) {
                    this.tableLoading = true;
                    const request = {
                        id: this.selectedCustomer.id,
                        tier: parseInt(this.updateCustomerTierModel.tier)
                    }


                    this.updateCustomerTier(request).then(response => {

                        this.tableLoading = false;
                        if (response.status === 200) {
                            this.loadCustomersData();
                            this.updateCustomerTierVisible = false
                            this.showSuccessAlert("Customer Details Updated Successfully")
                        } else {
                            this.showErrorAlert(response.data.messages)
                        }
                    },
                        error => {
                            this.tableLoading = false
                            this.showErrorAlert(JSON.stringify(error))
                        })
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },
        showDisabledCustomer(data) {
            this.tableLoading = true

            const request = {
                id: data.id,
                IsActive: false
            }

            // console.log("request | ", request)
            this.updateCustomerStatus(request).then(response => {

                this.tableLoading = false;
                if (response.status === 200) {
                    this.loadCustomersData();
                    this.showSuccessAlert("Customer Details Updated Successfully")
                } else {
                    this.showErrorAlert(response.data.messages)
                }
            },
                error => {
                    this.tableLoading = false
                    this.showErrorAlert(JSON.stringify(error))
                })
        },
        exportAllOrders() {
            // console.log("tableAllOrdersData | ", this.tableAllOrdersData)
            const dataToExport = [
                [
                    "Customer ID",
                    "Retailer Name",
                    "Phone Number",
                    "Type",
                    "Status"
                ],
            ];
            this.tableAllCustomersData.forEach((v) => {
                dataToExport.push([
                    v.id,
                    v.name,
                    v.phoneNumber,
                    `Tier ${v.tier}`,
                    v.status
                ]);
            });

            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.aoa_to_sheet(dataToExport);

            /* Add the worksheet to the workbook */
            XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

            /* generate file and send to client */
            XLSX.writeFile(wb, `Export-Customers-Data-${moment().format('DD-MM-YYYY')}.xlsx`);
            this.showSuccessAlert("Data Successfully Exported")
        },

        exportAllNewCustomers() {
            // console.log("tableAllOrdersData | ", this.tableAllOrdersData)
            const dataToExport = [
                [
                    "Customer ID",
                    "Retailer Name",
                    "Phone Number",
                    "Type",
                    "Status"
                ],
            ];
            this.tableNewCustomersData.forEach((v) => {
                dataToExport.push([
                    v.id,
                    v.name,
                    v.phoneNumber,
                    `Tier ${v.tier}`,
                    v.status
                ]);
            });

            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.aoa_to_sheet(dataToExport);

            /* Add the worksheet to the workbook */
            XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

            /* generate file and send to client */
            XLSX.writeFile(wb, `Export-New-Customers-Data-${moment().format('DD-MM-YYYY')}.xlsx`);
            this.showSuccessAlert("Data Successfully Exported")
        },

        exportAllActiveData() {
            // console.log("tableAllOrdersData | ", this.tableAllOrdersData)
            const dataToExport = [
                [
                    "Customer ID",
                    "Retailer Name",
                    "Phone Number",
                    "Type",
                    "Status"
                ],
            ];
            this.tableActiveCustomerData.forEach((v) => {
                dataToExport.push([
                    v.id,
                    v.name,
                    v.phoneNumber,
                    `Tier ${v.tier}`,
                    v.status
                ]);
            });

            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.aoa_to_sheet(dataToExport);

            /* Add the worksheet to the workbook */
            XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

            /* generate file and send to client */
            XLSX.writeFile(wb, `Export-Active-Customers-Data-${moment().format('DD-MM-YYYY')}.xlsx`);
            this.showSuccessAlert("Data Successfully Exported")
        },

        exportAllDisabled() {
            // console.log("tableAllOrdersData | ", this.tableAllOrdersData)
            const dataToExport = [
                [
                    "Customer ID",
                    "Retailer Name",
                    "Phone Number",
                    "Type",
                    "Status"
                ],
            ];
            this.tableInActiveCustomerData.forEach((v) => {
                dataToExport.push([
                    v.id,
                    v.name,
                    v.phoneNumber,
                    `Tier ${v.tier}`,
                    v.status
                ]);
            });

            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.aoa_to_sheet(dataToExport);

            /* Add the worksheet to the workbook */
            XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

            /* generate file and send to client */
            XLSX.writeFile(wb, `Export-Disabled-Customers-Data-${moment().format('DD-MM-YYYY')}.xlsx`);
            this.showSuccessAlert("Data Successfully Exported")
        },

        async showDeclinedOrderModal(order) {
            this.tableLoading = true;
            const request = {
                backOrderId: order.id,
                data: {
                    status: 5
                }
            }
            const response = await this.updateBackOrder(request)
            this.tableLoading = false;
            if (response.status === 200) {
                this.loadBackOrdersData();
                this.showSuccessAlert(`Back Order Canceled Successfully`)
            } else {
                this.tableLoading = false;
                // console.log('Error | ', response);
            }
        },

        showAddCustomerModal() {
            // this.$router.push('/request-product').catch(()=>{});
            this.addCustomerVisible = true
        },

        handleAddCustomerCancel() {
            this.addCustomerVisible = false;
        },

        handleUpdateCustomerCancel() {
            this.updateCustomerVisible = false
        },

        getAllCustomers(response) {
            if (response.status === 200) {

                this.tableAllCustomersData = []
                this.tableAllCustomersData = response.data.data.map(customer => ({
                    key: customer.id,
                    id: `#${customer.id}`,
                    name: customer.name,
                    phoneNumber: customer.phoneNumber,
                    tier: customer.tier,
                    status: customer.isActive ? 'Enabled' : 'Disabled',
                    action: customer
                }))
            } else {
                console.log("Error | ", response)
            }
        },

        getNewCustomers(response) {
            if (response.status === 200) {
                this.tableNewCustomersData = []
                const newCustomers = filterNewData14DaysAgo(response.data)
                newCustomers.forEach(customer => {
                    this.tableNewCustomersData.push({
                        key: customer.id,
                        id: `#${customer.id}`,
                        name: customer.name,
                        phoneNumber: customer.phoneNumber,
                        tier: customer.tier,
                        status: customer.isActive ? 'Enabled' : 'Disabled',
                        action: customer
                    })
                })
            } else {
                console.log("Error | ", response)
            }
        },

        getActiveCustomers(response) {
            if (response.status === 200) {
                this.tableActiveCustomerData = [];
                response.data.data.forEach(customer => {
                    if (customer.isActive) {
                        this.tableActiveCustomerData.push({
                            key: customer.id,
                            id: `#${customer.id}`,
                            name: customer.name,
                            phoneNumber: customer.phoneNumber,
                            tier: customer.tier,
                            status: customer.isActive ? 'Enabled' : 'Disabled',
                            action: customer
                        })
                    }
                })
            } else {
                console.log("Error | ", response)
            }
        },

        getInActiveCustomers(response) {
            if (response.status === 200) {
                this.tableInActiveCustomerData = [];
                response.data.data.forEach(customer => {
                    if (!customer.isActive) {
                        this.tableInActiveCustomerData.push({
                            key: customer.id,
                            id: `#${customer.id}`,
                            name: customer.name,
                            phoneNumber: customer.phoneNumber,
                            tier: customer.tier,
                            status: customer.isActive ? 'Enabled' : 'Disabled',
                            action: customer
                        })
                    }
                })
            } else {
                console.log("Error | ", response)
            }
        },

        getAllTiers(response) {
            if (response.status === 200) {
                this.availableTiers = [];
                const result = response.data.data.map(item => ({
                    tier: item.tier,
                    tierLabel: `Tier ${item.tier}`
                }))
                this.availableTiers = _.uniqWith(result, _.isEqual);
            } else {
                console.log("Error | ", response)
            }
        },

        showDeclinedActions(data) {
            const allowedDeclincedStatus = ['New', 'AwaitingConfirmation', 'Received', 'Firmed', 'Fulfilling']
            const result = allowedDeclincedStatus.includes(data.statusLabel) ? true : false
            return result
        },
        async loadCustomersData() {
            this.tableLoading = true
            const response = await this.getAllRetailers()
            this.getAllCustomers(response)
            this.getNewCustomers(response)
            this.getActiveCustomers(response)
            this.getInActiveCustomers(response)
            this.getAllTiers(response)

            this.tableLoading = false
        },
        handleAddCustomerSubmit() {
            this.$refs.addCustomerForm.validate(valid => {
                if (valid) {
                    this.loading = true;
                    // let productQuantity = {};

                    const retailerDetails = this.availableCommunity.find(community => community.id === this.addCustomerModel.communityId)

                    const request = {
                        communityId: this.addCustomerModel.communityId,
                        name: this.addCustomerModel.name,
                        phoneNumber: this.addCustomerModel.phoneNumber,
                        address: this.addCustomerModel.address,
                        locationLatitude: retailerDetails.locationLatitude,
                        locationLongitude: retailerDetails.locationLongitude
                    }


                    this.addNewCustomer(request).then(response => {

                        this.loading = false;
                        if (response.status === 200) {
                            this.loadCustomersData();
                            this.showSuccessAlert("New Customer Created Successfully")
                            this.$refs.addCustomerForm.resetFields();
                            this.addCustomerVisible = false;
                        } else {
                            this.showErrorAlert(response.data.messages)
                        }
                    },
                        error => {
                            this.loading = false
                            this.showErrorAlert(JSON.stringify(error))
                        })
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },

        handleUpdateCustomerSubmit() {
            this.$refs.updateCustomerForm.validate(valid => {
                if (valid) {
                    this.loading = true;
                    // let productQuantity = {};

                    const retailerDetails = this.availableCommunity.find(community => community.id === this.updateCustomerModel.communityId)
                    const request = {
                        id: this.selectedCustomer.id,
                        data: {
                            communityId: this.updateCustomerModel.communityId,
                            name: this.updateCustomerModel.name,
                            phoneNumber: this.updateCustomerModel.phoneNumber,
                            address: this.updateCustomerModel.address,
                            locationLatitude: retailerDetails.locationLatitude,
                            locationLongitude: retailerDetails.locationLongitude
                        }
                    }


                    this.updateNewCustomer(request).then(response => {

                        this.loading = false;
                        if (response.status === 200) {
                            this.loadCustomersData();
                            this.showSuccessAlert("Customer Details Updated Successfully")
                            this.$refs.updateCustomerForm.resetFields();
                            this.updateCustomerVisible = false;
                        } else {
                            this.showErrorAlert(response.data.messages)
                        }
                    },
                        error => {
                            this.loading = false
                            this.showErrorAlert(JSON.stringify(error))
                        })
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },

        async loadCommunities() {
            const response = await this.getAllCommunities()
            if (response.status === 200) {
                this.availableCommunity = response.data.data
            } else {
                // console.log("Error | ", response)
            }
        }

    },
    created() {
        if (this.loadCustomersData) {
            this.loadCustomersData()
        }

        if (this.loadCommunities) {
            this.loadCommunities()
        }
    }
}
</script>

<style scoped>
.actions {
    display: flex;
    justify-content: space-between;
}

.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}

.tableStyle>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
    color: #fff;
}

.tableStyle>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

a {
    color: #418a49;
}

a:hover {
    color: #418a49;
}

.rightSideinputText {
    width: 100%;
    border-radius: 5px;
}

.requestActions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
}

.card-container {
    background: none;
    overflow: hidden;
    /* padding: 24px; */
}

.card-container>.ant-tabs-card>.ant-tabs-content {
    height: 120px;
    margin-top: -16px;
}

.card-container>.ant-tabs-card>.ant-tabs-content>.ant-tabs-tabpane {
    background: #fff;
    padding: 16px;

}

.card-container>>>.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
    height: 40px;
    color: #98c14b;
    background: #e5efe7;
    border-color: #e5efe7;
    border-bottom: 1px solid #98c14b;
}

.card-container>>>.ant-tabs-tab {
    height: 40px;
    margin: 0;
    width: 217px;
    margin-right: 2px;
    padding: 0 16px;
    line-height: 38px;
    background: #fafafa;
    border: 1px solid #e8e8e8;

}

.card-container>>>.ant-tabs-tab:hover {
    color: #98c14b;
    /* background: #e5efe7; */
}

.card-container>>>.ant-badge-count {
    z-index: auto;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    color: #fff;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    white-space: nowrap;
    text-align: center;
    background: #98c14b;
    border-radius: 10px;
    box-shadow: 0 0 0 1px #fff;
}

.card-container>.ant-tabs-card>.ant-tabs-bar {
    border-color: #fff;
}

.card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab {
    border-color: transparent;
    background: transparent;
}

.card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab-active {
    border-color: #e5efe7;
    background: #e5efe7;
}

.ant-divider-horizontal {
    display: block;
    clear: both;
    width: 100%;
    min-width: 100%;
    height: 1px;
    margin: 8px 0;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
    background: #26A246;
    color: #fff;

}


.tableStyle>>>.ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle>>>.ant-table-header {
    background: #fff !important;
}
</style>